import React, { useEffect } from 'react'
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { BiHome, BiRefresh } from 'react-icons/bi';

import {
    AngleSmallLeft,
    Home,
} from '../../../../assets'

import '../../../../assets/icons/icons.css'
import './TopNav.css'
import { getHistory } from '../../../../application/actions/historyActions';
import { useDispatch } from 'react-redux';

const HistoryTopNav = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [scrolled, setIsScrolled] = React.useState(false);

    const buttonRefresh = () => {
        dispatch(getHistory());
    }

    let x = ['topnav-container'];
    if (scrolled) {
        x.push('background-white topnav-scrolled');
    }

    const handleScroll = () => {
        const offset = window.scrollY;
        // console.log(offset, 'offset')
        if (offset > 30) {
            setIsScrolled(true);
        }
        else {
            setIsScrolled(false);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    });

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className="white-space"></div>
            <div className="topnav-history-container">
                {/* <div className="topnav-left-side" onClick={() => {
                    if (props.isClicked) {
                        props.handleDetailClick();
                    }
                    else {
                        // dispatch(clearMerchantsDetails())
                        history.goBack()
                    }
                }}>
                    <AngleSmallLeft id="back-small-icon" />
                </div> */}
                <div className="topnav-center-side">
                    <span className="topnav-history-left">{props.title}</span>
                </div>
                <Link to={buttonRefresh} className="topnav-right-side">
                    <BiRefresh size={25} title="Home" color={'black'}/>
                </Link>
            </div>
        </>
    )
}

export default HistoryTopNav
